const useSalonMatchClickTracking = () => {
  try {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'use_salonfinder',
      });
    } else {
      setTimeout(() => {
        if (typeof window !== 'undefined' && window.dataLayer) {
          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({
            event: 'use_salonfinder',
          });
        }
      }, [process.env.GTM_DELAY]);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('There was an error sending data to Google Tag Manager: ', error);
  }
};

export default useSalonMatchClickTracking;
